import { useState, useEffect } from 'react'

import { loadGoogleApi, removeGoogleCallback } from '_libs/utils/google'
import { useEnvs } from '@marketplace-web/shared/environment'

const GOOGLE_MAPS_API_KEY = 'GOOGLE_MAPS_API_KEY'

function useLoadGoogleApi() {
  const googleApiKey = useEnvs(GOOGLE_MAPS_API_KEY)

  const [isGoogleApiLoaded, setIsGoogleApiLoaded] = useState(false)

  useEffect(() => {
    if (!googleApiKey) return undefined

    const handleGoogleApiLoaded = () => setIsGoogleApiLoaded(true)

    if (typeof window?.google?.maps !== 'undefined') return setIsGoogleApiLoaded(true)

    loadGoogleApi({
      apiKey: googleApiKey,
      onGoogleApiLoaded: handleGoogleApiLoaded,
    })

    return () => removeGoogleCallback(handleGoogleApiLoaded)
  }, [googleApiKey])

  return isGoogleApiLoaded
}

export default useLoadGoogleApi
